'use client';
import { useAuth } from '@/app/context/AuthContext';
import './page.css'
import { useEffect, useState } from 'react';
import Link from 'next/link';

function RcgisWebServicePage() {
    const {checkIsUserAuthenticated, checkIsUserApiKeyManager} = useAuth();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isApiKeyManager, setIsApiKeyManager] = useState(false);

    useEffect(() => {
        checkIsUserAuthenticated()
            .then(result => {
                setIsAuthenticated(result);
                if (result) {
                    checkIsUserApiKeyManager()
                        .then(result => setIsApiKeyManager(result));
                }
            })
            .catch(() => setIsAuthenticated(false));
    });

    const obtainCredentialsPageLink = (isAuthenticated && isApiKeyManager) ? "/getting-started/" : "https://info.cyclomedia.com/developerrequest"

    const codeExampleSting = `
<html lang="en"> 
<head> 
<meta charset="utf-8" /> 
<meta name="viewport" content="initial-scale=1,maximum-scale=1,user-scalable=no" />
<title>Cyclomedia ArcGIS JavaScript API Example</title> 
<link rel="stylesheet" href="https://js.arcgis.com/4.29/esri/themes/light/main.css" /> 
<script src="https://js.arcgis.com/4.29/"></script> 
<style> 
  html, body, #viewDiv { padding: 0; margin: 0; height: 100%; width: 100%; } 
  #menu { padding: 1em; } 
</style> 
<script> 
  require([ 
    "esri/WebScene", 
    "esri/views/SceneView", 
    "esri/layers/IntegratedMeshLayer", 
    "esri/config", 
    "esri/request" ], 
    (WebScene, SceneView, IntegratedMeshLayer, esriConfig, esriRequest) => { 
      const webscene = new WebScene(); 
      
      const params = new URLSearchParams(window.location.search); 
      var t = params.get("t") 
      
      const baseUrl = 'https://atlasapi.cyclomedia.com/i3s/arcgis/rest/services/3dnl/SceneServer'; 
  
   esriConfig.request.interceptors.push({ 
    urls: new RegExp(baseUrl, "i"), // Match your server URL 
    before: function(params) { 
      // Add authorization header 
      params.requestOptions.headers = params.requestOptions.headers || {}; 
      // Basic auth
      params.requestOptions.headers.Authorization = 'Basic <Base64-encoded Cyclomedia's username and password, separated by a colon>'; 
      // In case of API Key authorization, add header like below
      params.requestOptions.headers.Authorization = 'APIKey <Your API Key>'; 
     } 
  }); 
  fetch(baseUrl, { 
    method: 'GET', 
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': 'Basic ' //or 'APIKey' when using API Key authorization
      } 
    } 
  ) .then((response) => { return response.json(); })
    .then((json) => { 
      var count = 0; 
      json.layers.forEach((layer) => { 
        const l = new IntegratedMeshLayer({ 
          url: '\${baseUrl}/layers/\${count++}', 
          copyright: "Cyclomedia", 
          title: layer.name 
        }); 
        webscene.add(l); 
      }); 
    }); 
    const view = new SceneView({ 
      container: "viewDiv", 
      map: webscene, 
      qualityProfile: "high", 
      zoom: 1 
    }); 
  }); 
</script> 
</head> 
<body> <div id="viewDiv"> </div> 
</body> 
</html>
    `;
    
    return (
        <section className="pazlkchmsn">
            <div className="xjxghidyhk">
                <div className="vshugkagez" role="main">
                    <div className="flex flex-column flex-grow fill block">
                        <section className="ebpktekhjn ebpktekhjn-xl">
                            <div className="jnznarkcjk jnznarkcjk-xl jnznarkcjk-lg">
                                <div className="creegbalqr" role="article">
                                    <div className="card card-wiogy xntleozynm">
                                        <div className="table">
                                            <div className="tvidphzhou">
                                                <div className="dxffefactr">
                                                    <div className="ProseMirror">
                                                        <h1 id="Z70I9"><b>3DNL ArcGIS Web Service</b></h1>
                                                        <p>The Cyclomedia ArcGIS Web Service 3DNL, built on Esri&apos;s SLPK
                                                            (Scene Layer Package) and I3S (Indexed 3D Scene Layer)
                                                            standards, provides a high-fidelity, large-scale 3D
                                                            representation of urban environments. Seamlessly integrated
                                                            into the Esri ArcGIS Pro and ArcGIS Online
                                                            ecosystems, this service allows users to visualize, analyze,
                                                            and interact with accurate 3D models of cities,
                                                            infrastructure, and landscapes.</p>
                                                    </div>
                                                </div>
                                                <div className="nljvpdbuak"><img className="picture picture-rmxnk nmjbcvllii"
                                                        src="/images/mesh_image_dev_portal_2_resized.png"/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="pafflfxzwj" role="article">
                                    <div className="placeholder"></div>
                                </div>
                            </div>
                        </section>
                        <section className="tgqniprkda">
                            <div className="kdprnqefpi kdprnqefpi-md kdprnqefpi-lg">
                                <div className="wtiijhghaz wtiijhghaz-md" role="article"><img
                                        className="picture picture-default kqacsusxjm"
                                        src="/images/Cyclomedia_icons_key_color_rgb.png" alt="Picture" width="120"
                                        style={{width: "120px", height: "120px"}} height="120"/>
                                    <div className="ProseMirror">
                                        <h3 id="4SRJ7" className="text text-xl-align-center text text-align-center">
                                            <b>Obtain credentials</b></h3>
                                        <p className="text text-xl-align-center text text-align-center">Before you can start
                                            using the 3DNL ArcGIS Web Service, you need to have credentials. If you
                                            do not have them yet, please <Link href={obtainCredentialsPageLink} target="_self">use this form
                                                to request access</Link>.</p>
                                    </div><Link role="button" href={obtainCredentialsPageLink} target="_self"
                                        className="button button-primary ohriohqpsw"><span data-bind="text: label">Request
                                            your credentials</span></Link>
                                </div>
                                <div className="cqagocywvl cqagocywvl-md" role="article"><img
                                        className="picture picture-default hqpkaqlibk"
                                        src="/images/Cyclomedia_icons_files_color_rgb.png" alt="Picture" width="120"
                                        style={{width: "120px", height: "120px"}} height="120"/>
                                    <div className="ProseMirror">
                                        <h3 id="lwa6T" className="text text-xl-align-center text text-align-center"><b>Read
                                                the documentation</b></h3>
                                        <p className="text text-align-center">Everything you need to know about the use of
                                            our 3DNL ArcGIS Web Service can be found below in the <a
                                                href="/our-apis/3dnl-arcgis-web-service#Q3nyE" target="_self">Service
                                                Documentation</a>.</p>
                                    </div><a role="button" href="/our-apis/3dnl-arcgis-web-service#Q3nyE" target="_self"
                                        className="button button-primary puvrgazbzx"><span data-bind="text: label">Read the
                                            service documentation</span></a>
                                </div>
                                <div className="fstmayuatz fstmayuatz-md" role="article"><img
                                        className="picture picture-default spdpjddahr"
                                        src="/images/Cyclomedia_icons_lamp_color_rgb.png" alt="Picture" width="120"
                                        style={{width: "120px", height: "120px"}} height="120"/>
                                    <div className="ProseMirror">
                                        <h3 id="plSt1" className="text text-xl-align-center text text-align-center"><b>View
                                                our examples</b></h3>
                                        <p className="text text-xl-align-center text text-align-center">To help you getting
                                            started, we have created a set of code examples for you. You can use them as
                                            a basis for your own service requests.</p>
                                    </div><a role="button" href="/our-apis/3dnl-arcgis-web-service#vkd4d" target="_self"
                                        className="button button-primary wqmruzyqtd"><span data-bind="text: label">Explore
                                            the code examples</span></a>
                                </div>
                            </div>
                        </section>
                        <section className="pwvgwwzrix pwvgwwzrix-xl">
                            <div className="rhporyzpgh rhporyzpgh-lg">
                                <div className="jzwujkyoap" role="article">
                                    <div className="ProseMirror">
                                        <h1 id="Q3nyE" className="text text-xl-align-center"><b><span
                                                    className="colors-default-bg">Service Documentation</span></b></h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="uonschuhue uonschuhue-xl">
                            <div className="imqopqvizf imqopqvizf-lg">
                                <div className="jcnsozymgn" role="article">
                                    <div className="ProseMirror">
                                        <p>The 3D mesh is created from Cyclomedia&apos;s extensive aerial imagery and LiDAR
                                            data, delivering rich, photorealistic visualizations that support various
                                            GIS processes such as urban planning, asset management, and spatial
                                            analysis. The use of the SLPK and I3S formats ensures optimized streaming
                                            and efficient rendering of large datasets, even when handling complex
                                            cityscapes.</p>
                                        <p>The ArcGIS Web Service 3DNL I3S service is an ArcGIS service which can be
                                            accessed through this URL: <a
                                                href="https://atlasapi.cyclomedia.com/i3s/arcgis/rest/services/3dnl/SceneServer"
                                                target="_self"
                                                rel="noopener noreferrer">https://atlasapi.cyclomedia.com/i3s/arcgis/rest/services/3dnl/SceneServer</a>
                                        </p>
                                        <p className="text text-xl-align-left">This service can be used in <a
                                                href="https://www.esri.com/en-us/arcgis/products/arcgis-pro/overview"
                                                target="_blank" rel="noopener noreferrer">ArcGIS Pro</a>, <a
                                                href="https://www.arcgis.com/" target="_self"
                                                rel="noopener noreferrer">ArcGIS Online</a> and integrated with
                                            the <a href="https://developers.arcgis.com/javascript/latest/"
                                                target="_self" rel="noopener noreferrer">ArcGIS JavaScript API
                                                </a></p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="lwpguirdra lwpguirdra-xl">
                            <div className="rhporyzpgh rhporyzpgh-lg">
                                <div className="jvbpsvlmpf" role="article">
                                    <div className="ProseMirror">
                                        <h1 id="ImgRK" className="text text-xl-align-center"><b>ArcGIS Pro</b></h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="sotukxkizo sotukxkizo-xl">
                            <div className="sejyujoghf sejyujoghf-lg">
                                <div className="iuwncrezjc" role="article">
                                    <div className="ProseMirror">
                                        <p><b>1. Open a new project in ArcGIS Pro.</b></p>
                                        <p><b>2. Create a local Scene.</b></p>
                                    </div><img className="picture picture-default mrcppeybir"
                                        src="/images/arcgis-pro-create-new-scene.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>3. Go to Map navigation bar and choose ‘Add Data’ &gt; ‘From Path’ or
                                                directly choose ‘Add Data From Path’.</b></p>
                                    </div><img className="picture picture-default yfdnmkukzq"
                                        src="/images/arcgis-pro-add-data-from-path.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>4. Add the 3DNL layer (<a
                                                    href="https://atlasapi.cyclomedia.com/i3s/arcgis/rest/services/3dnl/SceneServer"
                                                    target="_self"
                                                    rel="noopener noreferrer">https://atlasapi.cyclomedia.com/i3s/arcgis/rest/services/3dnl/SceneServer</a>)
                                                to the Path input field.</b></p>
                                    </div><img className="picture picture-default mhguxbswru"
                                        src="/images/arcgis-pro-add-data-from-path-1.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>5. Choose ‘Add’.</b></p>
                                    </div><img className="picture picture-default ntxblkgwkz"
                                        src="/images/arcgis-pro-add-data-from-path-2.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>6. There will be a prompt to login. Add your Cyclomedia username and
                                                password.</b></p>
                                    </div><img className="picture picture-default hgqfnqwybd"
                                        src="/images/arcgis-pro-credentials.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>7. Complete steps.</b></p>
                                    </div><img className="picture picture-default jwolyewzjz"
                                        src="/images/arcgis-pro-complete.png" />
                                </div>
                            </div>
                        </section>
                        <section className="ykereostzg ykereostzg-xl">
                            <div className="rhporyzpgh rhporyzpgh-lg">
                                <div className="rslvbtbhwf" role="article">
                                    <div className="ProseMirror">
                                        <h1 id="sfNI3" className="text text-xl-align-center"><b>ArcGIS Online</b>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="ssklbtnzvx ssklbtnzvx-xl">
                            <div className="lakxgupdad lakxgupdad-lg">
                                <div className="tikrzywtpd" role="article">
                                    <div className="ProseMirror">
                                        <p><b>1. Open ArcGIS Online</b></p>
                                        <p><b>2. Check with your organization admin if the Cyclomedia 3DNL ArcGIS Web
                                                Service URL is added as a trusted server. For more information, refer
                                                to</b> <a
                                                href="https://doc.arcgis.com/en/arcgis-online/administer/configure-security.htm#ESRI_SECTION1_70CC159B3540440AB325BE5D89DBE94A"
                                                target="_blank" rel="noopener noreferrer">Configure security
                                                settings—ArcGIS Online Help | Documentation</a></p>
                                        <p><b>3. Create a WebScene.</b></p>
                                        <p><b>4. Use the &apos;+&apos; icon to create a Local Scene.</b></p>
                                    </div><img className="picture picture-default qecakfirij"
                                        src="/images/arcgis-online-1.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>5. Add a new layer and choose for ArcGIS web service.</b></p>
                                    </div><img className="picture picture-default fpcpmfuung"
                                        src="/images/arcgis-online-2.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>6. Fill the 3DNL Layer URL (<a
                                                    href="https://atlasapi.cyclomedia.com/i3s/arcgis/rest/services/3dnl/SceneServer"
                                                    target="_self"
                                                    rel="noopener noreferrer">https://atlasapi.cyclomedia.com/i3s/arcgis/rest/services/3dnl/SceneServer</a>)
                                                in the Layer URL box.</b></p>
                                    </div><img className="picture picture-default xzvcspsefx"
                                        src="/images/arcgis-online-3.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>7. Fill the prompt for adding username and password.</b></p>
                                    </div><img className="picture picture-default ajhkxpqclp"
                                        src="/images/arcgis-online-4.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>8. 3DNL is now successfully added to your Scene.</b></p>
                                    </div>
                                    <div className="ProseMirror">
                                        <p></p>
                                        <h1 id="2aLZV">How to use 3DNL in ArcGIS with the new API Keys</h1>
                                        <p>This article describes how API Keys can be used to authorize 3DNL in ArcGIS. The first way is to authorize 3DNL as a layer in the Scene Viewer, the second way is to save a Scene Layer as an item.</p>                                        
                                        <p><b>1) Authorize 3DNL as a layer in an ArcGIS web scene with API Key.</b></p>
                                        <p>In a local scene it is possible to add the 3DNL ArcGIS web service. This can be done with the following easy steps.</p>
                                        <p>1.	Open the Layer manager and click on ArcGIS web service</p>
                                        <img className='picture picture-default' src='/images/arc-gis-online-api-key-1.png'></img>
                                        <p></p>
                                        <p>2.	Fill in the Layer URL </p>
                                        <p>https://atlasapi.cyclomedia.com/i3s/arcgis/rest/services/3dnl/SceneServer</p>
                                        <p>3.	Configure custom parameters </p>
                                        <p>Parameter: apikey</p>
                                        <p>Value: fill your api key here</p>
                                        <img className='picture picture-default' src='/images/arc-gis-online-api-key-2.png'></img>
                                        <p></p>
                                        <p>4.	3DNL will now be available within the Scene Viewer. The layer with the API Key will be saved within the Scene and the Scene can be shared.</p>
                                        <img className='picture picture-default' src='/images/arc-gis-online-api-key-3.png'></img>
                                        <p></p>
                                        <p><b>2) Authorize 3DNL as an item in ArcGIS with API Key.</b></p>
                                        <p>At this moment custom parameters can not be saved in Scene layers and the API Keys can not be used to authorize 3DNL as an item in your ArcGIS Online or ArcGIS Enterprise environment.</p>
                                    </div>                                    
                                    <div className="ProseMirror">
                                        <p></p>
                                        <h1 id="2aZLV">Best practices for 3DNL in ArcGIS Online</h1>
                                    </div>
                                    <div className="ProseMirror">
                                        <p><b>1. Add local elevation layer</b></p>
                                        <p>With the Living Atlas, an elevation layer can be added in the RD New
                                            coordinate system. It can be found in the Living Atlas under the name
                                            &quot;Elevation 3D (RD)&quot;. This layer is based on AHN3 and AHN4 and corresponds to
                                            the coordinate system of 3DNL. Height layers can be used as a surface that
                                            provides base heights for other layers in scenes.</p>
                                    </div><img className="picture picture-default skeqwfaoud"
                                        src="/images/arcgis-online-bp-1.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p>When adding, the pop-up &apos;Data mismatch will appear, click on ‘Drop’ so that
                                            the projection of the scene is switched to RD New.</p>
                                        <p>To learn more about Applying Elevation in a 3D Scene, read Esri&apos;s <a
                                                href="https://storymaps.arcgis.com/stories/5c81727ee76043feb35324ab4b73cea1"
                                                target="_blank" rel="noopener noreferrer">Storymap</a> (in Dutch).</p>
                                    </div>
                                    <div className="ProseMirror">
                                        <p><b>2. Set the visibility range</b></p>
                                        <p>In the layer properties, which can be found for every layer in the Layer
                                            Manager, it is possible to set the visibility range of the 3DNL layer.</p>
                                    </div><img className="picture picture-default jmimqbzekl"
                                        src="/images/arcgis-online-bp-2.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p>It is advised to set a minimum Visibility range, for example of 1:15,000 –
                                            max. This makes sure that 3DNL is only loaded when the scene is sufficiently
                                            zoomed in.</p>
                                    </div><img className="picture picture-default lxxinwfvkd"
                                        src="/images/arcgis-online-bp-3.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>3. Make use of a base layer</b></p>
                                        <p>By adding a base layer the user has the possibility to go to the correct
                                            location in the scene. A suggestion to use as a base layer is the ‘Topo RD
                                            voor 3D’ which can be found in the Living Atlas.</p>
                                    </div><img className="picture picture-default duxmkynovu"
                                        src="/images/arcgis-online-bp-4.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p>The visibility range of both layers can also be combined, when 3DNL is
                                            visible starting at 1:15,000, the Topo layer can be visible <u>up to
                                                1:15,000</u>. For this the Visibility range has to be set ‘min –
                                            1:15,000’.</p>
                                    </div><img className="aappigkezd" src="/images/arcgis-online-bp-5.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p><b>4.&nbsp;Mesh modification</b></p>
                                        <p>Mesh modifications can be used to clip, mask or replace the 3DNL mesh. The
                                            modifications can be found in the layer properties in the Layer Manager.</p>
                                    </div><img className="picture picture-default xljdmkdzpg"
                                        src="/images/arcgis-online-bp-6.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p>The Mask modification can be used to show a certain part of the 3DNL mesh.
                                            The areas outside of the area will not be shown, which improves the
                                            performance of the 3DNL layer.</p>
                                    </div><img className="picture picture-default dvxdroivvl"
                                        src="/images/arcgis-online-bp-7.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p>The Clip modification gives the possibility to exclude a certain part of the
                                            mesh. This can be used to make other layers visible which would otherwise
                                            overlap the 3DNL mesh.</p>
                                    </div><img className="picture picture-default mrxtjtplwo"
                                        src="/images/arcgis-online-bp-8.png" />
                                    <div className="ProseMirror">
                                        <p></p>
                                        <p>Lastly the Replace modification can be used to adjust the height of the mesh
                                            inside the polygon. This can for example be used to flatten the mesh to
                                            ground level.</p>
                                        <p>More information about mesh modifications can be found <a
                                                href="https://doc.arcgis.com/en/arcgis-online/create-maps/scene-modify-mesh.htm"
                                                target="_self" rel="noopener noreferrer">here</a>.</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="yvzeexwkjo yvzeexwkjo-xl">
                            <div className="rhporyzpgh rhporyzpgh-lg">
                                <div className="pxyvuosszf" role="article">
                                    <div className="ProseMirror">
                                        <h1 id="vkd4d" className="text text-xl-align-center"><b>ArcGIS JavaScript API</b></h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="qpcgbvxthh qpcgbvxthh-xl">
                            <div className="myvbvnuxna myvbvnuxna-lg">
                                <div className="lhybadkkmb" role="article">
                                    <div className="ProseMirror">
                                        <p><b>See below code examples to start using the service with ArcGIS JavaScript
                                                API</b></p>
                                    </div>
                                    <div className="ProseMirror">
                                        <pre><code>{codeExampleSting}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="qhuzdlbacz qhuzdlbacz-xl">
                            <div className="rhporyzpgh rhporyzpgh-lg">
                                <div className="qwfrzyuvfk" role="article">
                                    <div className="ProseMirror">
                                        <h1 id="5cy94" className="text text-xl-align-center"><b>FAQ</b></h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="wwbzyerrpl wwbzyerrpl-xl">
                            <div className="aavdgzlznf aavdgzlznf-lg">
                                <div className="qnrkyunusb" role="article">
                                    <div className="ProseMirror">
                                        <ul className="ul ul-default">
                                            <li>
                                                <p>ArcGIS Pro version support</p>
                                                <ul className="ul ul-default">
                                                    <li>
                                                        <p>Version 3.3 and above</p>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <p>I have added the I3S service to ArcGIS Online, but run into
                                                    trouble.</p>
                                                <ul className="ul ul-default">
                                                    <li>
                                                        <p>Check with your organization admin to add the Cyclomedia 3DNL
                                                            ArcGIS Web Service URL as a trusted server. For more
                                                            information, refer to <a
                                                                href="https://doc.arcgis.com/en/arcgis-online/administer/configure-security.htm#ESRI_SECTION1_70CC159B3540440AB325BE5D89DBE94A"
                                                                target="_blank" rel="noopener noreferrer">Configure
                                                                security settings—ArcGIS Online Help | Documentation</a>
                                                        </p>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <p>ArcGIS JavaScript API support</p>
                                                <ul className="ul ul-default">
                                                    <li>
                                                        <p>Version 4.29 and above</p>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RcgisWebServicePage